<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.produitAchat.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAchat.affichage')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitAchat.affichage}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAchat.grattage')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitAchat.grattage}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAchat.laisserEnPlace')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitAchat.laisserEnPlace}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAchat.otTech')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitAchat.otTech}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAchat.loyer')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitAchat.loyer}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAchat.reglementTlpe')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitAchat.produitReglementTlpe}}
            </span>
          </b-field>
        </div>
        <div v-if="modulePresseActive" class="column is-6">
          <b-field :label="$t('detailSociete.produitAchat.produitAchatCommission')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitAchat.achatCommission}}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    societe: {
      type: Object,
      required: true,
    },
    modulePresseActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
